module.exports = __webpack_public_path__ + "static/media/solicitudesVerde.ecdab6bc.png";